import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, Text } from 'rebass';
import Helmet from 'react-helmet';
import {
  display,
  flexDirection,
  justifyContent,
  alignItems,
  height,
  overflow,
} from 'styled-system';
import styled, { createGlobalStyle } from 'styled-components';

import { CenterContentTemplate, Typography } from '@oca/ui';
import { i18n } from '@lib/i18n';

import { getOrganizationMeta } from '../lib/get-meta';

const ORG = process.env.REACT_APP_ORGANIZATION;

export function AuthPageTemplate({ heading, children, title }) {
  const meta = getOrganizationMeta(ORG);
  const { logo: Logo, favicon } = meta;
  const defaultTitle = i18n._(meta.title);

  return (
    <CenterContentTemplate>
      <Helmet defaultTitle={defaultTitle} titleTemplate={meta.titleTemplate}>
        {title && <title>{title}</title>}
        {favicon && <link rel="icon" href={favicon} />}
      </Helmet>
      <GlobalStyles />
      <FlexCard
        width="800px"
        boxShadow={1}
        bg="white"
        borderRadius={8}
        overflow="hidden"
      >
        <Box width={2 / 5} px={4} pt={5} pb={3}>
          <Typography variant="h1" fontWeight={400} paragraph>
            <Text as="span" color="secondary">
              {ORG && ORG.toUpperCase()}
            </Text>{' '}
            Digital Platform
          </Typography>
          {heading}
          {children}
        </Box>
        <HeroBlock width={3 / 5} bgImage={meta.bgImage}>
          <FlexCard
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            backgroundColor="rgba(0, 0, 0, 0.5)"
            height="100%"
          >
            <Box marginBottom={2}>
              <Logo fontSize={250} color="white" />
            </Box>
            <Typography variant="h1" fontWeight={300} color="white">
              {i18n._(meta.fullName) || ''}
            </Typography>
          </FlexCard>
        </HeroBlock>
      </FlexCard>
    </CenterContentTemplate>
  );
}

AuthPageTemplate.propTypes = {
  heading: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  children: PropTypes.node,
  title: PropTypes.string,
};

AuthPageTemplate.defaultProps = {
  children: null,
  title: null,
  heading: null,
};

const GlobalStyles = createGlobalStyle`
  #root { 
    background: linear-gradient(
      45deg,
      rgba(0, 117, 244, 1) 0%,
      rgba(0, 179, 255, 1) 100%
    )
  }
`;

const FlexCard = styled(Card)`
  ${display};
  ${flexDirection}
  ${justifyContent};
  ${alignItems};
  ${height};
  ${overflow};
`;

FlexCard.defaultProps = {
  display: 'flex',
};

// eslint-disable-next-line react/prop-types
const HeroBlock = ({ width, children, bgImage }) => (
  <FlexCard
    display="block"
    width={width}
    backgroundImage={`url(${bgImage})`}
    backgroundRepeat="no-repeat"
    backgroundSize="cover"
  >
    {children}
  </FlexCard>
);
